export enum WS_STATUS {
  OPEN = WebSocket.OPEN,
  CLOSED = WebSocket.CLOSED,
  CONNECTING = WebSocket.CONNECTING,
  ERROR = 'ERROR',
}
